export const reports = {
    tenantType: {
        renter: 'arrendatario',
        owner: 'propietario',
        unknown: 'desconocido',
    },
    "yearly_cashflow_title": "Informe anual del flujo de caja {{year}}",
    "monthly_cashflow_title": "Cargos mensuales {{monthName}} {{year}} - Total <span class='amount'> {{currency}} {{amount}} <\/span>",
    "monthly_cashflow_table_title": "Cargos mensuales {{monthName}} {{year}} - Total {{amount}} {{currency}}",
    "monthly_partner_cashflow_table_title_tooltip": "Bllink charges and payment documentation. Also includes inactive buildings",
    "export_title": "Informe mensual de los socios",
    "cheques_export_title": "Informe sobre los cheques de los socios",
    "apartment_cashflow_title": "Pago por apartamento {{apartmentNumber}}",
    "cheques_title": "Informe de cheques {{monthName}} {{year}} - Total {{amount}} {{currency}}",
    "monthly_future_cashflow_title": "Informe de cargos mensuales futuros - {{monthName}} {{year}} - Total {{amount}} {{currency}}",
    "yearly_by_months_title": "Meses pagados para {{year}}",
    "yearly_by_months_title_new": "Informe Anual",
    "special_payments_report_title": "Pagos especiales",
    "yearly_by_months_one_time_title": "Detalles de los pagos únicos del año {{year}}",
    "tenantName": "Nombre del inquilino",
    "buildingTitle": "Título del edificio",
    "ownerName": "Nombre del propietario",
    "ownerPhone": "Teléfono del propietario",
    "ownerEmail": "Correo electrónico del propietario",
    "renterName": "Nombre del arrendatario",
    "renterPhone": "Teléfono del arrendatario",
    "renterEmail": "Correo electrónico del arrendatario",
    "apartmentName": "Apartamento",
    "buildingName": "Edificio",
    "date_to_pay": "Fecha de cobro",
    "ownership_type": "Propietario o Inquilino",
    "backoffice": "retool backoffice",
    "payment_comment": "Comentario de pago",
    "receipt": "Recibo",
    "done_by": "Realizado por",
    "transferredAt": "Transferido al edificio",
    "actions": "Acciones",
    "confirmation": "Confirmación del pago",
    "confirmation_link_text": "Confirmar",
    "billing_date": "Fecha de cobro",
    "apartment_number": "Apartamento {{apartmentNumber}}",
    "paid_out_of_total": "Pagado {{paid}} de {{total}}",
    "paid": "Pagado {{paid}}",
    "paid_full": "Pagado en su totalidad {{paid}}",
    "paid_none": "No pagado",
    "paid_for": "Paid for",  // TODO: translate me
    "amount": "Amount",  // TODO: translate me
    "scheduled_to_pay": "Pago futuro {{scheduledToPay}} de {{total}}",
    "failed_payment": "El pago falló. El inquilino recibirá un enlace para actualizar los detalles del crédito. No es necesario tomar ninguna medida",
    "monthly_cashflow_sub_title": "Total pagado con tarjeta de crédito:",
    "none_paid": "No pagado",
    "partially_paid": "Parcialmente pagado",
    "paid_new": "Pagado",
    "paid_full_new": "Pagado en su totalidad",
    "paid_none_new": "No pagado",
    "scheduled_to_pay_only_new": "Pago futuro",
    "monthly_cashflow_sub_title_future": "Total en pagos futuros",
    "monthly_cashflow_sub_title_early_withdrawal": "Total por retiro anticipado. Disponible para administrador. No incluye honorarios",
    "scheduled_to_pay_only": "Pago futuro {{scheduledToPay}}",
    "paid_explanation": "Se establece el pago pagado o futuro",
    "part_paid_explanation": "Pago parcial",
    "tenant_claim_paid_explanation": "Marcado como pagado",
    "empty_table": "No se encontraron registros",
    "empty_table_for": "No se encontraron registros para {{name}}",
    "monthly_on_going": "Pagos mensuales",
    "monthly_debt": "Deudas mensuales",
    "one_time_debt": "Deuda única",
    "one_time_payment": "Pago único",
    "unknown": "Desconocido",
    "paid_with": "Pagado con",
    "tenantEmail": "Correo electrónico",
    "tenantPhone": "Teléfono",
    "monthlyFee": "Cuota mensual",
    "tenant_list_title": "Lista de inquilinos",
    "drag_and_drop_info": "Arrastra el archivo aquí para subir los detalles",
    "updatedTenantList": "Se actualizó la lista de inquilinos",
    "notUpdatedTenantList": "No se actualizó la lista de inquilinos",
    "date_of_expense": "Fecha de gastos",
    "vendor_name": "Nombre del proveedor",
    "expense_frequency": "Frecuencia de los gastos",
    "print_tooltip": "Pulsa aquí para imprimir la tabla",
    "excel_tooltip": "Pulsa aquí para exportar la tabla a Excel",
    "csv_tooltip": "Pulsa aquí para exportar la tabla a CSV",
    "hashavshevet_tooltip": "Presione aquí para exportar datos para Hashavshevet",
    "balance_title": "Informe de balance para",
    "balance_total": "Total",
    "balance_total_bllink": "Total en Bllink",
    "creditCards": "Total en tarjetas de crédito",
    "cheques": "Total en cheque",
    "wires": "Total en alambres",
    "cash": "Total en efectivo",
    "legacyPayment": "Total en pagos heredados",
    "bankCharge": "Total en cargos bancarios",
    "autoCheque": "Total en cheques automáticos",
    "tenantRecord": "Total en registros de inquilinos",
    "other": "Total en otros métodos",
    "balance_total_cash": "Total en efectivo",
    "balance_total_cheque": "Total en cheque",
    "balance_total_bank": "Total en cargo bancario",
    "balance_income": "Ingresos totales",
    "balance_expense": "Gasto total",
    "balance_monthly_total": "Total mensual",
    "not_paid_explanation": "Cargo futuro previsto",
    "balance_money_in": "Entrada de dinero",
    "balance_money_out": "Salida de dinero",
    "balance_diff": "Diferencia",
    "dateRangeSameYear": "Las fechas de inicio/finalización deben ser del mismo año",
    "show_all": "Mostrar todo",
    "hide": "Ocultar",
    "save": "Guardar",
    "tenantsSaved": "¡Se guardaron los datos de los inquilinos!",
    "nothingToSave": "No hay datos para guardar",
    "fieldError": "{{field}} no es válido",
    "deleteExpenseSuccess": "¡Se eliminó el registro de gastos!",
    "deleteExpenseConfirmText": "¿Estás seguro de que deseas eliminar el gasto?",
    "deleteExpenseRecurring": "Eliminar todos los gastos recurrentes",
    "deleteOneMonthExpense": "Eliminar solo los gastos de este mes",
    "cancel": "Cancelar",
    "partner_debt_list": "Informe general de deudores",
    "monthly_reports_at_partner_level": "Informe de facturación mensual",
    "building_debt_list": "Lista de deudas del edificio",
    "one_time_comment": "Detalles del pago único",
    "monthly_comment": "Meses a pagar",
    "mc_dashboard_title": "Tablero para <name>",
    "mc_dashboard": "Tablero de MC",
    "total_debt_title": "Deuda total: ",
    "total_debt_sub_title_partner": "* only debts from active buildings",
    "total_debt_title_tooltip": "For active buildings only",
    "total_debt_sub_title_tooltip": "will be equal to dashboard one time and on going minus the debts from inactive buildings",
    "go_back": "A la lista de edificios",
    "back_to_dashboard": "Al tablero de MC",
    "total_charged": "Total cobrado",
    "total_debt": "Deuda total",
    "total_future": "Pagos futuros totales",
    "partner_debt_title": "Informe general de deudores de:",
    "building_debt_title": "Lista de deudas del edificio para:",
    "refund": {
        "tooltip": "Reembolso",
        "modalTitle": "Confirmar reembolso",
        "modalConfirmText": "¿Estás seguro de que quieres realizar un reembolso?",
        "refundNotificationSuccess": "¡El reembolso se realizó con éxito!",
        "refundNotificationError": "El reembolso no se completó",
        "btns": {
            "yes": "Sí",
            "no": "No"
        },
        "future": {
            "tooltip": "Suspender todos los pagos futuros",
            "modalTitle": "Confirmar cancelación de pago",
            "modalConfirmText": "¿Estás seguro de que deseas cancelar el pago?",
            "refundNotificationSuccess": "El plan de pago futuro se canceló. ¡No se cobrará al inquilino!",
            "refundNotificationError": "El pago no se canceló"
        },
        "refund": "reembolso"
    },
    "delete": {
        "tooltip": "Eliminar",
        "modalTitle": "Eliminar pago",
        "notificationSuccess": "¡Los registros se eliminaron con éxito!",
        "notificationNoUpdates": "No se actualizó ningún registro",
        "notificationFailure": "Error al eliminar el pago sin conexión",
        "radioLabels": {
            "oneMonth": "Eliminar solo el pago de este mes",
            "onePayment": "Eliminar solo este pago",
            "allPayments": "Eliminar todos los pagos recurrentes",
            "allNextPayments": "Eliminar todos los próximos pagos recurrentes",
        },
        "btns": {
            "confirm": "Confirmar",
            "cancel": "Cancelar"
        }
    },
    "apartment": {
        "monthly": "Mensual",
        "oneTime": "Única vez",
        "full": "Informe completo",
        "year": "Año",
        "tenantDetails": "Detalles del inquilino",
        "tenantsPage": "Puedes editar los datos de los inquilinos en la página de la lista de inquilinos",
        "paid": "Pagado",
        "totalPaid": "Total pagado",
        "fee": "Total a pagar",
        "diff": "Izquierda"
    },
    "paymentRequestResults": {
        "fallBackSuccessEmail": "El correo electrónico a {{to}} se envió correctamente",
        "fallBackSuccessSMS": "El SMS a {{to}} se envió correctamente",
        "fallBackErrorEmail": "Error al enviar el correo electrónico a {{to}}",
        "fallBackErrorSMS": "Error al enviar SMS a {{to}}",
        "errorNoEmail": "No se proporciona correo electrónico para {{to}}",
        "errorNoPhone": "No se proporciona teléfono para {{to}}",
    },
    "paymentRequestPopUp": {
        "sendAll": "Enviar a todos los inquilinos",
        "selectAll": "Seleccionar todo",
        "selectAllExcludeOneMonth": "Todo excepto las deudas de este mes solamente",
        "paymentTitle": "Solicitud de pago",
        "allInfoTitle": "Toda la información",
        "howToSendLabel": "¿Cómo deseas enviar la solicitud del pago?",
        "sendToLabel": "Enviar solicitud de pago a",
        "recipientsSelect": "Selección de destinatarios",
        "recipientType": "Tipo de destinatario",
        "requestMethods": "Envíe una solicitud a través de",
        "sendBuildingRequestLabel": "Enviar solicitud de pago {{name}}",
        "tenantHelloText": "Hola [Nombre del inquilino]",
        "buildingPaymentAddress": "Su edificio en la dirección de {{address}} departamento {{apartmentNumber}} te pide que pagues el comité de la casa",
        "buildingHelpInfo": "Para ver los detalles y confirmar la solicitud de pago, vaya a la página del edificio a través del enlace",
        "importantNote": "Es importante tener en cuenta que si es inquilino, asegúrese de que los meses marcados para el pago sean solo hasta el final del contrato.",
        "onBehalf": "A nombre de [Partner Name]",
        "problemWithLink": "Si no puede hacer clic en el enlace, responda en el mensaje y haga clic en el enlace una vez más*",
        "currentMonthOnlyDebt": "Solo deuda del mes actual",
        "labels": {
            "sms": "Enviar SMS",
            "sendEmail": "Enviar correo electrónico",
            "sendIvr": "Enviar IVR",
            "owner": "Propietario",
            "renter": "Inquilino",
            "name": "Nombre",
            "phone": "Teléfono",
            "email": "Correo electrónico",
            "sendWa": "Enviar WA directo"
        },
        "btns": {
            "send": "Enviar",
            "saveSend": "Guardar y enviar"
        },
        "thanksTitle": "¡Gracias!",
        "requestTitle": "Se envió tu solicitud",
        "requestSuccess": "Enviado a inquilinos seleccionados",
        "requestSuccessTo": "Enviado a los inquilinos seleccionados desde el apartamento {{apartmentNumber}} edificio {{buildingID}}",
        "requestError": "Algo salió mal",
        "waText": "היי {{personName}}\n הבניין שלך בכתובת {{buildingAddress}} דירה {{apartmentNumber}} מבקש ממך תשלום עבור ועד הבית\n לצפייה בפרטים ואישור בקשת התשלום יש להיכנס לעמוד הבניין דרך הלינק\n {{paymentLink}}\n חשוב לשים כי במידה והינך שוכר/ת, יש לוודא שהחודשים המסומנים לתשלום הם עד סיום החוזה בלבד\n *במידה ולא ניתן ללחוץ על הלינק, יש להשיב חזרה בהודעה וללחוץ על הלינק פעם נוספת\n בשם {{buildingManagerName}}\n",
        "sendWaNote": "Requiere estar conectado a WA en esta computadora"
    },
    "debtListFilteringPopUp": {
        "title": "Filtrado de informes de deudas",
        "thisMontDebtsLabel": "Filtrar apartamentos con deudas solo este mes"
    },
    "yearlyByMonths": {
        "mainTitle": "Actualización manual del administrador del apartamento {{apartmentName}}, año {{year}}",
        "managerUpdateApartment": "Actualización manual de apartamento",
        "monthlyFee": "Cuota mensual",
        "amountPaid": "Monto pagado"
    },
    "transaction": {
        'tenant_record_approved': 'Informe de inquilino aprobado',
        'tenant_record_rejected': 'Informe de inquilino cancelado',
        'tenant_record_rejected_and_redirect': 'Reporte de inquilino cancelado, se puede documentar medio de pago',
        'tenant_record_transaction_failed': 'La transacción fue fallida',
    },
    "partnerMonthlyReportTitle": "Informe mensual del socio para",
    "monthly_cashflow_cheque_sub_title": "Total en cheques",
    "yearly_by_one_time_title": "Informe anual de pagos únicos",
    "cheque_deposit_tooltip": "Haga click aquí para imprimir el informe de cheques para un depósito bancario",
    "cheque_confirmation_id": "Número de cheque",
    "download_tooltip": "Haga click aquí para descargar en PDF",
    "legacyPaymentsUpdated": "El pago manual se configuró correctamente, la página se actualizará en un segundo y la información aparecerá en la pantalla",
    "legacyPaymentsFailed": "Error al configurar el pago manual",
    "total_debt_col": "Deuda total",
    "total_to_pay": "Total a pagar",
    "payment_for": "Pago para",
    "total": "Total",
    "4_last_digits": "últimos 4 dígitos",
    "percentage": "Percentage",
    "sendRequest": "Enviar solicitud",
    "confirm": "Confirmar",
    "setPayment": "Establecer pago",
    "deleteExpense": "Borrar",
    "payGiftPage_step2_tenantType_Lessee": "Inquilino",
    "payGiftPage_step2_tenantType_Owner": "Propietario",
    "tenantTypeUnknown": "",
    "expenses_monthly_title": "Informe de gastos",
    "expenses_report_title": "Informe de gastos",
    "expenses_monthly_subtitle": "Total expenses amount for this month",
    "payment_type": "Payment type",
    "frequency": "Frequency",
    "confirmation_id": "Confirmation ID",
    "bank_reconsile": "Bank reconsile",
    "note": "Note",
    "download_files": "Download files",
    "file_not_found": "Archivo no encontrado",
    "edit_payment_details": "Edit payment details",
    "edit_expense_details": "Edit expense details",
    "open_confirmation": "Confirmación de pago",
    "add_payment_details": "Agregar detalles de pago",
    "delete_expense": "Eliminar gasto",
    "unpaid": "Non-paid",
    "oneTime": "Una vez",
    "recurring": "Recurrente",
    "apt": "Apt",
    "chargeApt": "Realizar pago",
    "paymentMethod": "Payment method",
    "charge_date": "Fecha de cargo:",
    "charge_date_title": "Charge date", // TODO: translate me
    "deposit_date": "Fecha de deposito:",
    "balance_report_title": "Reporte de balance",
    "opening_account": "Opening Bank Amount",
    "actual_balance": "Saldo bancario al inicio de ",
    "building_tenant_records_list": "Lista de registros de inquilinos del edificio",
    "auto_campaign": "Campaña automática",
    "auto_campaign_instructions": "Descargar instrucciones",
    "mark_payment": "Marcar pago",
    "record_different_months": "Reject Record and record again for tenant",
    "add_meaning_of_payment": "Agregar un medio de pago",
    "total_tenant_records_title": "Registros totales de inquilinos: ",
    "building_tenant_records_title": "Lista de registros de inquilinos del edificio para",
    "tenant_report_marked_as_paid": "Informe de inquilino marcado como pagado",
    "month_marked_as_paid": "Mes marcado como pagado",
    "debtListActions": {
        "sendWarningLetter": "Enviar carta de advertencia",
        "sendRequest": "Enviar solicitud",
        "setPayment": "Set payment",
        "aptNotes": "Notas de apts",
        "downloadWarningLetter": "Descargar carta de advertencia"
    },
    "debtListNew": {
        "selectApartment": "Seleccione un apartamento de la lista",
    },
    "balance_report_subtitle": "En esta página puede realizar un seguimiento del saldo de gastos e ingresos.",
    "tenant_list_subtitle": "En esta página puede actualizar los contactos de los apartamentos",
    "total_apartments": "Apartamentos totales",
    "add_payment": "Agregar pago",
    "add_contact": "Agregar contacto",
    "edit_contact": "Editar contacto",
    "delete_contact": "Borrar contacto",
    "delete_apartment": "Eliminar apartamento",
    "apartment_deleted": "Se eliminó el apartamento {{apartmentNum}}",
    "total_contacts": "Número total de contactos",
    "isPrimary": "Contacto primario",
    "total_charged_balance": "Total cobrado",
    "set_expense_title": "Balance",
    "confirmation_title": "Confirmación",
    "fast_search": "Búsqueda rápida",
    "debt_report_title": "Informe de deuda para",
    "debt_report_subtitle": "En esta página puede realizar un seguimiento de los inquilinos responsables.",
    "total_debts": "Deudas totales",
    "debt_type": "Tipo de deuda",
    "total_amount": "Cantidad total",
    "tenant_details": "Detalles de los inquilinos",
    "debt_details": "Detalles de la deuda",
    "for": "Para",
    "monthly_fee": "Cuota mensual",
    "special_payment": "Pago especial",
    "monthly_fee_and_spec_payment": "Cuota mensual y pago especial",
    "stop_plans": {
        "action": "Plan(es) de parada",
        "action_tooltip": "Detener pagos futuros",
        "confirm": "Presione aprobar para cancelar todos los pagos futuros",
        "approve": "Aprobar",
        "success_notification": "Los pagos seleccionados se detuvieron con éxito",
        "empty_selection_notification": "Ningún pago seleccionado para detener",
        "no_payments": "No hay pagos para dejar de encontrar",
    },
    "edit_apartment_payments": {
        "stop_success": "Pagos seleccionados detenidos con éxito",
        "charge_dates_success": "Las fechas de cargo de los pagos seleccionados se actualizaron con éxito",
        "empty_selection": "No hay pagos seleccionados para continuar",
        "action": "Editar pagos de apartamento",
        "title": "Editar apartamento {{apartmentNumber}} pagos",
        "subtitle": "Elija los pagos que le gustaría editar",
        "cancel_payments": "Cancelar Pagos",
        "change_charge_date": "Cambiar Fecha de Cobro",
        "items_selected": "elementos seleccionados",
        "no_payments": "No se encontraron pagos disponibles",
    },
    "mark_primary": "Marcar contacto como primario",
    "mark_legal": "Marcar contacto en estado legal",
    "mark_manager": "Marcar contacto como administrador",
    "filtering": "Filtración",
    "phone_is_unavailable": "No hay número disponible",
    "collection_report": "Informe de colección",
    "accounting_service": "Green Invoice morning",
    "maintenance_service": "Maintenance service",
    "bank_deposit": "Deposito bancario",
    "bllink_charges": "Bllink cargos",
    "apt_num": "Número de apt",
    "bank_code": "Codigo bancario",
    "account": "Cuenta",
    "expire_date": "Fecha de caducidad",
    "card_type": "Tipo de tarjeta",
    "all_statuses": "Todos los estados",
    "total_tenants": "Total inquilinos",
    "for_clarification": "Pagos por aclaración",
    "failed_transactions": "Transacciones fallidas",
    "update_credit_card": "Actualizar los datos de la tarjeta de crédito",
    "reasons": {
        "MUST_BE_PENDING": "El pago debe estar pendiente",
        "MUST_BE_OFFLINE": "El pago debe ser fuera de línea",
    },
    "yearly_collection_report": "Informe de recaudación anual",
    "special": "Especial",
    "charged": "argado",
    "debt": "Deuda",
    "future": "Futuro",
    "collection_open_confirmation": "Abrir página de confirmación",
    "collection_refund": "Reembolso",
    "collection_cancel": "Cancelar",
    "expenses_deposit_date": "Fecha de depósito",
    "pdf": "PDF",
    "excel": "Excel",
    "csv": "CSV",
    "print": "Print",
    "send": "Enviar reporte",
    "send_report_modal": {
        "title": "Enviar un informe al comité de la casa",
        "set_tenant_as_building_manager": "Actualizar un inquilino como administrador del edificio",
        "update_tenant_contact": "Actualizar a un inquilino como contacto principal del apartamento",
        "send_to_email": "Envío a correo electrónico"
    },
    "total_needed_tooltip": "Importe previsto para el cobro en el intervalo de fechas",
    "total_charged_tooltip": "Cargos depositados en el banco en el período seleccionado (incluidos los métodos de pago)",
    "balance_diff_tooltip": "La diferencia no se refiere a pagos cobrados fuera del rango de fechas",
    "pdf_note": "La lista de inquilinos se adjunta a este informe.",
    "special_debt": "Deuda especial",
    "details": "Detalles",
    "planned": "planificada",
    "fileName": "Nombre del archivo",
    "fileType": "Tipo de archivo",
    "uploadDate": "Fecha de carga",
    "uploadedBy": "Subido por",
    "size": "Tamaño",
    "addFile": "Agregar archivo",
    "ran_into_problem": "Ups... Nos encontramos con un problema",
    "uploaded_file_not_identified": "No pudimos identificar el archivo cargado. Es posible que nuestro equipo necesite revisar el archivo",
    "mark_transactions_manually": "Hasta entonces... las transacciones que se ingresan en Blink se pueden marcar y ajustar manualmente",
    "understood": "Entendí, gracias",
    "deposit": "Depósito",
    "deductions": "Deducciones",
    "fileUploaded": "Su archivo fue subido. Será redirigido a la pestaña de actualización manual para continuar",
    "totalOffsets": "Compensaciones totales",
    "moreDetails": "Más detalles",
    "charges": "Cargos",
    "awaitingApproval": "En espera de la aprobación final",
    "producedByBllink": "Este documento fue producido usando el sistema Bllink",
    "issueDate": "Fecha de asunto:",
    "noDataAvailable": "Datos no disponibles",
    "lastTurn": "último turno",
    "messageType": "Tipo de mensaje",
    "nextFace": "Siguiente cara en",
    "removeFromCampaign": "Eliminar de la campaña",
    "addToCampaign": "Agregar a la campaña",
    "markedApartments": "Apartamentos Marcados",
    "payments": "Pagos",
    "tenants": "Inquilinos",
    "tenant": "Inquilino",
    "history": "Historia",
    "card": "Tarjeta",
    "previousTenants": "Inquilinos anteriores",
    "mainTenants": "Principales inquilinos",
    "managerNotes": "Gerente",
    "bllinkNotes": "Bllink",
    "downloadInvoice": "Descargar recibo",
    "refundPayment": "Haciendo un credito",
    "stopPlan": "Cancelación de pago futuro",
    "noPartnerIDError": "No se proporciona el ID de socio.",
    "status": {
        "awaiting_withdrawal": "En espera de retiro",
        "pending_approval": "Aprobación pendiente",
        "approved": "Aprobado",
        "pulled_from_building": "Cargado con éxito",
        "failed": "Fallido",
    }
};
